module.exports = __webpack_public_path__ + "media/images/emblems/Rechthalten-coat_of_arms-a93a9a8b07fa28ebfa11e236faeeb5d7.svg";